/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import { extend } from 'underscore';

import ExerciseEditHeader from './ExerciseEditHeader';
import MediaEditor from './MediaEditor';
import Tooltip from './Tooltip';
import NameAutocomplete from './NameAutocomplete';
import ButtonAddToLibrary from './ButtonAddToLibrary';
import { Typography } from '@mui/material';
import exerciseVideoImage from '/static/images/exercise-video.jpg';
import howToShootImage from '/static/images/how-to-shoot@2x.png';
import homescreenImage from '/static/images/homescreen@2x.png';

class NutritionExerciseEdit extends React.Component {
  constructor(props) {
    super(props);
    this.merge = this.merge.bind(this);
    this.onToggleMinimize = this.onToggleMinimize.bind(this);
    this.descriptionChanged = this.descriptionChanged.bind(this);
    this.linkChanged = this.linkChanged.bind(this);
    this.mediaChanged = this.mediaChanged.bind(this);
    this.imageChanged = this.imageChanged.bind(this);
    this.nameChanged = this.nameChanged.bind(this);
    this.validate = this.validate.bind(this);
  }
  merge(newData) {
    let data = extend(this.props.data, newData);
    this.props.onChange(this.props.id, data);
  }
  onToggleMinimize() {
    if (this.props.minimizeDisabled) return;
    this.merge({ minimized: !this.props.data.minimized });
  }
  descriptionChanged(ev) {
    this.merge({ description: ev.target.value });
  }
  linkChanged(ev) {
    this.merge({ link: ev.target.value });
  }
  mediaChanged(media) {
    this.merge({ media });
  }
  imageChanged(image) {
    this.merge({ image });
  }
  nameChanged(name) {
    this.merge({ name });
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }
  render() {
    //console.log('[NutritionExerciseEdit] render() called.');

    let buttonAddToLibrary = null;
    if (this.props.libraryEnabled) {
      buttonAddToLibrary = (
        <ButtonAddToLibrary
          influencerId={this.props.influencerId}
          template={this.props.data}
          statusBar={this.props.statusBar}
        />
      );
    }

    let link = null;
    if (this.props.data.link) {
      if (
        this.props.data.link.indexOf('http://') === -1 &&
        this.props.data.link.indexOf('https://') === -1
      ) {
        link = `http://${this.props.data.link}`;
      } else {
        link = this.props.data.link;
      }
    }

    let content = (
      <div className="exercises-description">
        <div className="nutritionExerciseMediaColumn">
          <div className="input-holder">
            <label>Nutrition video</label>
          </div>
          <div className="media-box">
            <MediaEditor
              format="video"
              className="vertical"
              metadata={this.props.data.media}
              onChange={this.mediaChanged}
              onRemove={this.mediaChanged}
            />
          </div>
          <div className="tooltips">
            {/* info tooltip */}
            <Tooltip className="info">
              <div className="mobile">
                <section>
                  <Typography variant="h1">Nutrition video</Typography>
                  <p>
                    Record yourself using the nutrition product or food item.
                    They are displayed in fullscreen, so make sure to shoot in
                    portrait!
                  </p>
                  <ul>
                    <li>
                      <strong>Maximum size &amp; length:</strong> 100 mb and 1-5
                      sec.
                    </li>
                    <li>
                      <strong>Supported browsers:</strong> Safari or Chrome
                    </li>
                  </ul>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">nutrition video</Typography>
                  <p>
                    Record yourself using the nutrition product or food item.
                    They are displayed in fullscreen, so make sure to shoot in
                    portrait!
                  </p>
                  <ul>
                    <li>
                      <strong>Format:</strong> Portrait (9:16)
                    </li>
                    <li>
                      <strong>Size:</strong> max 100 mb
                    </li>
                    <li>
                      <strong>Length:</strong> 1-5 sec.
                    </li>
                    <li>
                      <strong>Browser:</strong> Safari or Chrome
                    </li>
                  </ul>
                </section>
                <section>
                  <img className="shoot-vertical" src={exerciseVideoImage} />
                </section>
              </div>
            </Tooltip>
            {/* camera tooltip */}
            <Tooltip className="camera">
              <div className="mobile">
                <section>
                  <Typography variant="h1">How to shoot</Typography>
                  <p>
                    The video will be shown in fullscreen, so shoot with your
                    iPhone in portrait mode (9:16).
                  </p>
                  <p>
                    We suggest you record just one repetition and keep it under
                    5 seconds in length.
                  </p>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">How to shoot</Typography>
                  <p>
                    The video will be shown in fullscreen, so shoot with your
                    iPhone in portrait mode (9:16).
                  </p>
                  <p>
                    We suggest you record just one repetition and keep it under
                    5 seconds in length.
                  </p>
                </section>
                <section>
                  <img className="shoot-vertical" src={howToShootImage} />
                </section>
              </div>
            </Tooltip>
            {/* edit tooltip */}
            <Tooltip className="scissors">
              <div className="mobile">
                <section>
                  <Typography variant="h1">How to edit</Typography>
                  <p>
                    Use the app{' '}
                    <a href="https://itunes.apple.com/us/app/splice-video-editor-movie/id409838725?mt=8">
                      Splice
                    </a>{' '}
                    from the App Store to trim your video.
                  </p>
                  <p>
                    Compress to have longer video. Use{' '}
                    <a href="https://itunes.apple.com/us/app/video-compressor/id482465886?mt=8">
                      Video Compressor
                    </a>{' '}
                    to compress to less than 100 mb if necessary.
                  </p>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">How to edit (desktop)</Typography>
                  <p>
                    Use{' '}
                    <a target="_blank" href="http://online-video-cutter.com">
                      Video Cutter
                    </a>{' '}
                    to crop your video and compress it to less than 100 mb if
                    necessary. Select ‘720p’ in quality and ‘mp4’ in format.
                  </p>
                  <p>Remember to shoot with iPhone in portrait mode.</p>
                </section>
                <section>
                  <Typography variant="h1">How to edit (mobile)</Typography>
                  <p>
                    Use the app{' '}
                    <a href="https://itunes.apple.com/us/app/splice-video-editor-movie/id409838725?mt=8">
                      Splice
                    </a>{' '}
                    from the App Store to trim your video.
                  </p>
                  <p>
                    Compress to have longer video. Use{' '}
                    <a href="https://itunes.apple.com/us/app/video-compressor/id482465886?mt=8">
                      Video Compressor
                    </a>{' '}
                    to compress to less than 100 mb if necessary.
                  </p>
                </section>
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="nutritionExerciseMediaColumn">
          <div className="input-holder">
            <label>
              Nutrition image<strong className="warning">*</strong>
            </label>
          </div>
          <div className={`media-box ${this.validate('image')}`}>
            <MediaEditor
              format="image"
              className="square"
              metadata={this.props.data.image}
              onChange={this.imageChanged}
              onRemove={this.imageChanged}
            />
          </div>
          <div className="tooltips">
            {/* info tooltip */}
            <Tooltip className="info">
              <div className="mobile">
                <section>
                  <Typography variant="h1">Nutrition image</Typography>
                  <p>Still image of nutrition product or food item(s).</p>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">Product image</Typography>
                  <p>Still image of nutrition product or food item(s).</p>
                </section>
                <section>
                  <img
                    className="homescreen"
                    src={homescreenImage}
                    width="175"
                    height="235"
                  />
                </section>
              </div>
            </Tooltip>
            {/* camera tooltip */}
            <Tooltip className="camera">
              <div className="mobile">
                <section>
                  <Typography variant="h1">How to shoot</Typography>
                  <p>
                    Because product images are square, we suggest you shoot with
                    your phone in portrait mode (vertical). iPhones shoot in
                    3:4, so we suggest you crop the picture to 1:1 before
                    uploading.
                  </p>
                  <a className="actionLink button transparent-button">
                    Watch video
                  </a>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">How to shoot</Typography>
                  <p>
                    Because product images are square, we suggest you shoot with
                    your phone in portrait mode (vertical). iPhones shoot in
                    3:4, so we suggest you crop the picture to 1:1 before
                    uploading.
                  </p>
                  <a className="actionLink button transparent-button">
                    Watch video
                  </a>
                </section>
                <section>
                  <img className="shoot-vertical" src={howToShootImage} />
                </section>
              </div>
            </Tooltip>
            {/* edit tooltip */}
            <Tooltip className="scissors">
              <div className="mobile">
                <section>
                  <Typography variant="h1">How to crop</Typography>
                  <p>
                    Download{' '}
                    <a
                      target="_blank"
                      href="https://itunes.apple.com/us/app/croppola/id549869191?mt=8"
                    >
                      croppola
                    </a>{' '}
                    from the App Store and crop your picture to 1:1.
                  </p>
                  <ol>
                    <li>Select your picture</li>
                    <li>Select "square" via the first icon</li>
                    <li>Then save via the third icon</li>
                  </ol>
                  <a className="actionLink button transparent-button">
                    Watch video
                  </a>
                </section>
              </div>
              <div className="large">
                <section>
                  <Typography variant="h1">How to crop (mobile)</Typography>
                  <p>
                    Download{' '}
                    <a
                      target="_blank"
                      href="https://itunes.apple.com/us/app/croppola/id549869191?mt=8"
                    >
                      croppola
                    </a>{' '}
                    from the App Store and crop your picture to 1:1.
                  </p>
                  <ol>
                    <li>Select your picture</li>
                    <li>Select "square" via the first icon</li>
                    <li>Then save via the third icon</li>
                  </ol>
                  <a className="actionLink button transparent-button">
                    Watch video
                  </a>
                </section>
                <section>
                  <Typography variant="h1">How to crop (desktop)</Typography>
                  <p>
                    Visit{' '}
                    <a target="_blank" href="https://croppola.com/">
                      croppola
                    </a>{' '}
                    to crop your picture to 1:1.
                  </p>
                  <ol>
                    <li>Select your picture</li>
                    <li>Select 1:1 in aspect ratio</li>
                    <li>Click "download this crop"</li>
                  </ol>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=NqDgesUSr7w"
                    className="actionLink button transparent-button"
                  >
                    Watch video
                  </a>
                </section>
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="description-col">
          <div className="input-holder">
            <label>
              Nutrition name<strong className="warning">*</strong>
            </label>
            <NameAutocomplete
              value={this.props.data.name}
              onChange={(e) => {
                if (e && e.name) {
                  this.nameChanged(e.name);
                }
                if (e && e.description) {
                  this.descriptionChanged({ target: { value: e.description } });
                }
                this.nameChanged(e.name);
              }}
              placeholder="Enter nutrition title"
              maxLength={60}
            />
          </div>
          <div className="input-holder">
            <label>Nutrition description</label>
            <textarea
              value={this.props.data.description}
              rows={3}
              cols={80}
              maxLength={2000}
              onChange={this.descriptionChanged}
              placeholder="Enter nutrition description."
            />
          </div>
          <div className="input-holder">
            <label>Link to nutrition product</label>
            <input
              value={this.props.data.link}
              onChange={this.linkChanged}
              placeholder="Paste nutrition product link here."
              maxLength={255}
            />
            <a
              className="remove"
              onClick={(e) => {
                if (!link) e.preventDefault();
              }}
              href={link}
              target="_blank"
            >
              Preview link
            </a>
          </div>
        </div>
        <div className="progress-box"></div>
        {buttonAddToLibrary}
      </div>
    );

    return (
      <div className="nutritionExerciseEdit">
        <ExerciseEditHeader
          id={this.props.id}
          exerciseLength={this.props.exerciseLength}
          index={this.props.index}
          data={this.props.data}
          minimizeDisabled={this.props.minimizeDisabled}
          deleteDisabled={this.props.deleteDisabled}
          onToggleMinimize={this.onToggleMinimize}
          onMoveUp={this.props.onMoveUp}
          onMoveDown={this.props.onMoveDown}
          onDelete={this.props.onDelete}
        />
        {this.props.data.minimized ? '' : content}
      </div>
    );
  }
}

export default NutritionExerciseEdit;
